window.addEventListener( 'load', function() {
		gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

        let smoother = document.getElementById("smooth-content");
  
		let header = document.getElementById("site-branding");
		let endmenuscroll = document.getElementById("footer");
		
		let hamburger = document.getElementById("hamburger");
		let mobilemenu = document.getElementById("mobileNavigation");
		
		let closeMenu = document.querySelector('.closeMenu');
		let menuOverlay = document.querySelector('.menuOverlay');
		
		//hamburger.onclick = function() {
			//mobilemenu.classList.toggle('active');
			//menuOverlay.classList.toggle('active');
		//};
		
		//closeMenu.onclick = function() {
			//mobilemenu.classList.remove('active');
			//menuOverlay.classList.remove('active');
		//};

        //Sticky Header
		gsap.to(".site-branding", {
			scrollTrigger: {
				start: "0 top",
				end: 99999,
				opacity: 1, 
				ease: "power1.out",
				toggleClass: { className: "sticky", targets: ".site-branding"},
				toggleActions: 'play none none reverse',
			}
		});

        const link = document.getElementById('HeaderMenu-treatments');
        const submenu = document.querySelector('.treatmentsSubMenu');

        let isTouch = false;

        // Detect touch device
        window.addEventListener('touchstart', () => {
          isTouch = true;
        }, { once: true });

        // Desktop hover
        link.addEventListener('mouseenter', () => {
          if (!isTouch) submenu.classList.add('active');
        });
      
        submenu.addEventListener('mouseenter', () => {
          if (!isTouch) submenu.classList.add('active');
        });
      
        submenu.addEventListener('mouseleave', () => {
          if (!isTouch) submenu.classList.remove('active');
        });

        // Mobile tap toggle
        link.addEventListener('click', (e) => {
          if (isTouch) {
            e.preventDefault(); // Prevent link on first tap
            submenu.classList.toggle('active');
          }
        });
      
        // Close submenu on outside tap (mobile)
        document.addEventListener('click', (e) => {
          if (isTouch && !link.contains(e.target) && !submenu.contains(e.target)) {
            submenu.classList.remove('active');
          }
        });

  document.querySelectorAll('.anchorLink').forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.getAttribute('href');
      const targetEl = document.querySelector(targetId);

      if (targetEl) {
        const offset = 50;
        const targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });

});